import React from "react";
import { OutlinedInput } from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { Tooltip } from "@my-scoot/component-library-legacy";

import {
  TEMPLATE_KEYS,
  TemplateConfig,
  SidebarConfig,
  DEFAULT_COVER_IMAGE,
} from "../../../constants";

import { ErrorText, ImageUploader } from "../../../widgets";
import { IMAGE_SECTION_KEY_PATH } from "features/Common/modules/ExlyImage/constants/ExlyImage.constants";
import style from "../style.module.css";

import { COVER_SECTION_CONFIG } from "ui/pages/TemplatePreview/constants.js";
import useTemplatePreview from "ui/pages/TemplatePreview/hooks/useTemplatePreview";
import { COVER_SECTION_TEXTS, COVER_SECTION_FIELDS } from "../sidebar.constant";

export const CoverSection = (props) => {
  const {
    state,
    setField,
    errorState,
    setErrorMessage,
    enableError,
    templateData,
    disableAllEdits,
  } = props;

  const { validateText } = useTemplatePreview();

  const templateSlug = state?.template?.slug || COVER_SECTION_TEXTS.MODERN_SLUG;
  const fullWidth = TemplateConfig?.[templateSlug]?.coverImage?.width;
  const width = 200;
  const height = 200 / TemplateConfig?.[templateSlug]?.coverImage.aspect_ratio;
  const baseAspectRatio = width / height;

  const mobileImageWidth = 200;
  const mobileImageHeight =
    200 /
    TemplateConfig?.[state?.template?.slug]?.mobileCoverImage?.aspect_ratio;

  return (
    <>
      {SidebarConfig.showGetInTouchSection.includes(
        templateData?.slug
      ) ? null : (
        <>
          <div className={style.fieldContainer}>
            <div className={style.label}>
              {COVER_SECTION_TEXTS.DEFAULT_COVER_IMAGE_LABEL}
            </div>
            <div className={style.field}>
              <ImageUploader
                hideRecommendedText
                uploadUrl={
                  state.cover_image ||
                  DEFAULT_COVER_IMAGE?.[state?.template?.slug]
                }
                setUploadUrl={(firebaseUrl) =>
                  setField(COVER_SECTION_FIELDS.COVER_IMAGE, firebaseUrl)
                }
                className={style.imageFieldStyle}
                photoWidgetClassName={style.imageFieldInnerStyle}
                hoverText={COVER_SECTION_TEXTS.HOVER_TEXT}
                fullWidth={fullWidth}
                width={width}
                height={height}
                borderRadius="0%"
                query={COVER_SECTION_TEXTS.COVER_QUERY}
                id={COVER_SECTION_TEXTS.ID_WEBSITE_COVER}
                disabled={disableAllEdits}
                uploadViaOptimization
                sectionName={IMAGE_SECTION_KEY_PATH.HOME_PAGE}
              />
            </div>
            <div className={style.photoWidgetText}>
              {COVER_SECTION_TEXTS.RECOMMENDED_FORMAT_DEFAULT(
                fullWidth,
                Math.round(fullWidth / baseAspectRatio)
              )}
            </div>
          </div>

          {state?.template?.slug === TEMPLATE_KEYS.UNLOCK && (
            <div className={style.fieldContainer}>
              <div>
                <span className={style.label}>
                  {COVER_SECTION_TEXTS.MOBILE_COVER_IMAGE_LABEL}
                </span>
                <Tooltip
                  title={COVER_SECTION_TEXTS.MOBILE_COVER_IMAGE_TOOLTIP}
                  color="primary"
                  arrow
                >
                  <InfoOutlinedIcon className={style.tooltip} />
                </Tooltip>
              </div>
              <div className={style.field}>
                <ImageUploader
                  hideRecommendedText
                  uploadUrl={
                    state?.social_info?.mobile_cover_image ||
                    state.cover_image ||
                    DEFAULT_COVER_IMAGE?.[state?.template?.slug]
                  }
                  setUploadUrl={(firebaseUrl) =>
                    setField(
                      COVER_SECTION_FIELDS.MOBILE_COVER_IMAGE,
                      firebaseUrl
                    )
                  }
                  className={style.imageFieldStyle}
                  photoWidgetClassName={style.imageFieldInnerStyle}
                  hoverText={COVER_SECTION_TEXTS.HOVER_TEXT}
                  fullWidth={
                    TemplateConfig?.[state?.template?.slug]?.mobileCoverImage
                      ?.width
                  }
                  width={mobileImageWidth}
                  height={mobileImageHeight}
                  borderRadius="0%"
                  query={COVER_SECTION_TEXTS.COVER_QUERY}
                  id={COVER_SECTION_TEXTS.ID_MOBILE_COVER}
                  disabled={disableAllEdits}
                  uploadViaOptimization
                  sectionName={IMAGE_SECTION_KEY_PATH.HOME_PAGE}
                />
              </div>
              <div className={style.photoWidgetText}>
                {COVER_SECTION_TEXTS.RECOMMENDED_FORMAT_MOBILE}
              </div>
            </div>
          )}

          <div className={style.fieldContainer}>
            <div className={style.label}>
              {COVER_SECTION_TEXTS.PAGE_TITLE_LABEL}
            </div>
            <div className={style.field}>
              <OutlinedInput
                className={style.input}
                value={state?.social_info?.website_heading}
                name={COVER_SECTION_TEXTS.INPUT_NAME_TITLE}
                placeholder="Enter page title"
                disabled={disableAllEdits}
                inputProps={{ maxLength: COVER_SECTION_CONFIG.MAX_NAME_LENGTH }}
                onChange={(e) => {
                  const inputVal = `${e.target.value || ""}`;
                  setField(COVER_SECTION_FIELDS.WEBSITE_HEADING, inputVal);
                  validateText({
                    value: inputVal,
                    enableError,
                    setErrorMessage,
                    enableErrorText:
                      COVER_SECTION_FIELDS.ERROR_KEY_WEBSITE_HEADING,
                    maxLength: COVER_SECTION_CONFIG.MAX_NAME_LENGTH,
                    errorMessage: COVER_SECTION_TEXTS.ERROR_MAX_LENGTH,
                  });
                }}
                onBlur={() => {
                  enableError(COVER_SECTION_FIELDS.ERROR_KEY_WEBSITE_HEADING);
                  if (state?.social_info?.website_heading) {
                    setField(
                      COVER_SECTION_FIELDS.WEBSITE_HEADING,
                      state?.social_info?.website_heading?.trim()
                    );
                  }
                }}
              />
              <ErrorText
                errorState={errorState}
                fieldKey={COVER_SECTION_FIELDS.ERROR_KEY_WEBSITE_HEADING}
              />
            </div>
          </div>

          <div className={style.fieldContainer}>
            <div className={style.label}>
              {COVER_SECTION_TEXTS.SHORT_BIO_LABEL}
            </div>
            <div className={style.field}>
              <OutlinedInput
                className={style.input}
                value={state?.social_info?.website_desc}
                name={COVER_SECTION_TEXTS.INPUT_NAME_SHORT_DESC}
                placeholder="Enter short bio"
                disabled={disableAllEdits}
                inputProps={{ maxLength: COVER_SECTION_CONFIG.MAX_DESC_LENGTH }}
                onChange={(e) => {
                  const inputVal = e.target.value || "";
                  setField(COVER_SECTION_FIELDS.WEBSITE_DESC, inputVal);
                  validateText({
                    value: inputVal,
                    enableError,
                    setErrorMessage,
                    enableErrorText:
                      COVER_SECTION_FIELDS.ERROR_KEY_WEBSITE_DESC,
                    minLength: COVER_SECTION_CONFIG.MIN_NAME_LENGTH,
                    maxLength: COVER_SECTION_CONFIG.MAX_DESC_LENGTH,
                    minLengthMessage: COVER_SECTION_TEXTS.ERROR_MIN_BIO_LENGTH,
                    errorMessage: COVER_SECTION_TEXTS.ERROR_MAX_LENGTH,
                  });
                }}
                onBlur={() => {
                  enableError(COVER_SECTION_FIELDS.ERROR_KEY_WEBSITE_DESC);
                  if (state?.social_info?.website_desc) {
                    setField(
                      COVER_SECTION_FIELDS.WEBSITE_DESC,
                      state?.social_info?.website_desc?.trim()
                    );
                  }
                }}
              />
              <ErrorText
                errorState={errorState}
                fieldKey={COVER_SECTION_FIELDS.ERROR_KEY_WEBSITE_DESC}
              />
            </div>
          </div>
        </>
      )}

      {state?.template?.slug === TEMPLATE_KEYS.UNFOLD ? (
        <div className={style.fieldContainer}>
          <div className={style.label}>
            {COVER_SECTION_TEXTS.GET_IN_TOUCH_HEADER_LABEL}
          </div>
          <div className={style.field}>
            <OutlinedInput
              className={style.input}
              value={state?.social_info?.interest_helper_text}
              name={COVER_SECTION_TEXTS.INPUT_NAME_OFFERINGS_CTA}
              disabled={disableAllEdits}
              multiline
              rows={3}
              onChange={(e) => {
                const inputVal = e.target.value;
                setField(COVER_SECTION_FIELDS.INTEREST_HELPER_TEXT, inputVal);
                if (inputVal.length > 30) {
                  setErrorMessage(
                    COVER_SECTION_FIELDS.ERROR_KEY_INTEREST_HELPER_TEXT,
                    COVER_SECTION_TEXTS.ERROR_OFFERINGS_CTA_LENGTH(
                      inputVal.length
                    )
                  );
                } else {
                  setErrorMessage(
                    COVER_SECTION_FIELDS.ERROR_KEY_INTEREST_HELPER_TEXT,
                    null
                  );
                }
              }}
              onBlur={() => {
                enableError(
                  COVER_SECTION_FIELDS.ERROR_KEY_INTEREST_HELPER_TEXT
                );
                if (state?.social_info?.interest_helper_text) {
                  setField(
                    COVER_SECTION_FIELDS.INTEREST_HELPER_TEXT,
                    state?.social_info?.interest_helper_text?.trim()
                  );
                }
              }}
            />
          </div>
        </div>
      ) : null}

      {state?.template?.slug !== TEMPLATE_KEYS.ELEMENTARY ? (
        <div className={style.fieldContainer}>
          <div className={style.label}>
            {COVER_SECTION_TEXTS.GET_IN_TOUCH_BTN_LABEL}
          </div>
          <div className={style.field}>
            <OutlinedInput
              className={style.input}
              value={state?.social_info?.interest_cta_text}
              name={COVER_SECTION_TEXTS.INPUT_NAME_INTEREST_CTA}
              disabled={disableAllEdits}
              inputProps={{ maxLength: COVER_SECTION_CONFIG.MAX_BUTTON_TEXT }}
              onChange={(e) => {
                const inputVal = e.target.value;
                setField(COVER_SECTION_FIELDS.INTEREST_CTA_TEXT, inputVal);
                validateText({
                  value: inputVal,
                  enableError,
                  setErrorMessage,
                  enableErrorText:
                    COVER_SECTION_FIELDS.ERROR_KEY_INTEREST_CTA_TEXT,
                  maxLength: COVER_SECTION_CONFIG.MAX_BUTTON_TEXT,
                  errorMessage: COVER_SECTION_TEXTS.ERROR_MAX_LENGTH,
                });
              }}
              onBlur={() => {
                enableError(COVER_SECTION_FIELDS.ERROR_KEY_INTEREST_CTA_TEXT);
                if (state?.social_info?.interest_cta_text) {
                  setField(
                    COVER_SECTION_FIELDS.INTEREST_CTA_TEXT,
                    state?.social_info?.interest_cta_text?.trim()
                  );
                }
              }}
            />
            <ErrorText
              errorState={errorState}
              fieldKey={COVER_SECTION_FIELDS.ERROR_KEY_INTEREST_CTA_TEXT}
            />
          </div>
        </div>
      ) : null}
    </>
  );
};
